// extracted by mini-css-extract-plugin
module.exports = {"section":"a10a3f92e9--section--thYaw","shadow":"a10a3f92e9--shadow--SDsPr","borders":"a10a3f92e9--borders--EWmXe","spaces":"a10a3f92e9--spaces--R0zJ7"};